<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '280px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false" >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('选择人员')" prop="userId">
                <a-select :placeholder="$t('请选择人员')" v-model="model.userId">
                  <a-select-option :value="item.userId" v-for="item in personnelList">{{item.userRealname}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('人员电话')" prop="userPhone">
                <a-input v-model="model.userPhone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    // mixins: [JeecgListMixin],
    name: 'ProcessingPersonnelModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/ticket/ticketsUser/add",
          edit: "/jeecg-engineering/ticket/ticketsUser/edit",
          queryById: "/jeecg-engineering/ticket/ticketsUser/queryById",
          userList: "/sys/user/list",
        },
        personnelList: [],
      }
    },
    computed: {
      validatorRules() {
        return {
          userId: [{required:true,message:this.$t('请选择人员'),trigger:'change'}],
        }
      }
    },
    watch:{
      'model.userId':{
        handler(val){
          if(val){
            let params = this.personnelList.find(per=>per.userId == val);
            if(params){
              this.$set(this.model,'userName',params.userName);
              this.$set(this.model,'userPhone',params.userPhone);
              this.$set(this.model,'userRealname',params.userRealname);
            }
          }
        }
      }
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.userList,{status:1,pageSize:999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                userId: item.id,
                userName: item.username,
                userRealname: item.realname,
                userPhone: item.telephone || item.phone
              });
            });
          }
        });
      },
      add() {
        this.visible = true;
        this.model = {};
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        this.getPersonnelList();
      },
      edit(record) {
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record));
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        this.getPersonnelList();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>